import styled from 'styled-components';

interface IProps2 {
  listHeight?: string;
}

export const InnerListStyled = styled.div<IProps2>`
  ${p => (p.listHeight ? { height: p.listHeight, overflowY: 'scroll' } : {})}
`;
